import { Node, Edge } from "reactflow";

export interface UseGraphActionsProps {
    nodes: Node[];
    edges: Edge[];
    moveToNode: (nodeId?: string) => void;
    setTriggerNameFilter: (triggerName: string) => void;
}

export interface UseGraphActions {
    edgeClick: (
        event: React.MouseEvent<Element, MouseEvent>,
        node: Edge<any>
    ) => void;
    nodeClick: (
        event: React.MouseEvent<Element, MouseEvent>,
        node: Node<any>
    ) => void;
}

const useGraphActions = ({
    edges,
    nodes,
    moveToNode,
    setTriggerNameFilter,
}: UseGraphActionsProps): UseGraphActions => {
    const edgeClick = (
        event: React.MouseEvent<Element, MouseEvent>,
        node: Edge<any>
    ) => {
        event.preventDefault();
        event.stopPropagation();
        const targetNode = edges.find((edge) => edge.id === node.id)?.target;
        moveToNode(targetNode);
    };

    const nodeClick = (
        event: React.MouseEvent<Element, MouseEvent>,
        node: Node<any>
    ) => {
        event.preventDefault();
        event.stopPropagation();
        setTriggerNameFilter(node.data.triggerName ?? "");
    };

    return {
        edgeClick,
        nodeClick,
    };
};

export default useGraphActions;
